import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Tooltip extends Vue {
  @Prop() content: string;

  get contentChunks(): string[] {
    return (this.content || '').split('\n');
  }
}
